import { render, staticRenderFns } from "./modal-schedule-video-call.vue?vue&type=template&id=e97f9530&scoped=true&"
import script from "./modal-schedule-video-call.vue?vue&type=script&lang=js&"
export * from "./modal-schedule-video-call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97f9530",
  null
  
)

export default component.exports